import React from "react";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import AutoSizer from "react-virtualized-auto-sizer";
import { ComponentType } from "react";
import { ListChildComponentProps } from "react-window";

interface InfiniteScrollableListProps {
    children: ComponentType<ListChildComponentProps<any>>;
    isItemLoaded: (index: number) => boolean;
    itemCount: number;
    loadMoreItems: (startIndex: number, stopIndex: number) => void;
    itemSize: number;
}

const InfiniteScrollableList: React.FC<InfiniteScrollableListProps> = ({
    children,
    isItemLoaded,
    itemCount,
    loadMoreItems,
    itemSize
}) => {

    return (
        <AutoSizer>
            {({ height, width }) => (
                <InfiniteLoader
                    isItemLoaded={isItemLoaded}
                    itemCount={itemCount}
                    loadMoreItems={loadMoreItems}
                >
                    {({ onItemsRendered, ref }) => (
                        <List
                            height={height}
                            width={width}
                            itemCount={itemCount}
                            itemSize={itemSize}
                            onItemsRendered={onItemsRendered}
                            ref={ref}
                        >
                            {children}
                        </List>
                    )}
                </InfiniteLoader>
            )}
        </AutoSizer>
    );
};

export default InfiniteScrollableList;
